import { makeStyles, Theme } from '@material-ui/core';
import { constants } from 'theme/constants';
import { colors } from 'theme/colors';

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    background: colors.HEADER_FOOTER,
    boxShadow: 'none',
    '& $profileBar': {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    '& $navBar': {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    zIndex: 1201,
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: constants.HEADER_HEIGHT,
    maxWidth: 1280,
    margin: '0 auto',
    [theme.breakpoints.down('md')]: {
      padding: '0px 24px',
    },
  },
  logoAndNav: {
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logoIcon: {
    textDecoration: 'none',
  },
  sportEndorse: {
    marginRight: 120,
    [theme.breakpoints.down('sm')]: {
      marginRight: 60,
    },
  },
  navBar: {},
  profileBar: {},
  toolbarBox: {
    display: 'flex',
  },
  burger: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  drawerContainer: {
    width: 232,
    backgroundColor: colors.WHITE,
    padding: theme.spacing(2),
    height: 'calc(100% - 64px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  drawer: {
    top: 64,
  },
  profileCardBtn: {
    height: 40,
  },
  profileCardBtnLabel: {
    textAlign: 'left',
    justifyContent: 'flex-start',
  },
  btnsBlock: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  link: {
    textTransform: 'uppercase',
    fontSize: 12,
    color: colors.LINK_GRAY,
    textDecoration: 'none',
  },
  linksBlock: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  btnLogIn: {
    marginRight: theme.spacing(2),
    padding: '7px 46px',
    border: '1px solid #d9dde9',
  },
  btnSignUp: {
    padding: '7px 46px',
  },
}));

export { useStyles };
